import { Button } from '~/components/ui/button'

export function LogoutButton() {
  return <Button href='/auth/signout'>로그아웃</Button>
}
